export default __webpack_public_path__ + "static/media/amaze-14.ada2d307.jpg";